const testimonies = [
  {
    image:
      "https://images.unsplash.com/photo-1633367583895-08545d733dfe?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    small: "Anthony Johnson, CEO of Creative Minds ",
    text: "Easyb Studio transformed our online presence with a stunning website that perfectly captures our brand's essence. Their team was professional, responsive, and delivered exceptional results. We're thrilled with our website",
  },
  {
    image:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    small: "Davis Christiana, Wosin tech ",
    text: "We were impressed by Easyb Studio's attention to detail and commitment to quality. They built a website that exceeded our expectations, and their support has been top-notch. We highly recommend Easyb Studio for all your website development needs.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1624797432677-6f803a98acb3?q=80&w=386&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    small: "Emily Rodriguez, Owner of Blooming Designs ",
    text: "Easyb Studio's expertise in website development is unmatched. They created a beautiful, user-friendly website for our business, and the process was seamless. Their team is talented, friendly, and dedicated to delivering outstanding results. We're so grateful for their services!",
  },
  {
    image:
      "https://images.unsplash.com/photo-1537511446984-935f663eb1f4?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    small: "Mark Davis, Founder of Tech Solutions ",
    text: "Working with Easyb Studio was a game-changer for our brand. They took our vision and transformed it into a sleek, professional website that truly reflects who we are. The communication was smooth, the turnaround time was impressive, and the final product exceeded our expectations. We couldn't be happier!",
  },
  {
    image:
      "https://images.unsplash.com/photo-1699205016830-02f55e7b44d8?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    small: "Marie Hunt, CEO of Solo Bolo ",
    text: "Easyb Studio delivered excellence from start to finish. Their attention to detail, creative approach, and technical skill made the entire web development process effortless. The team was responsive, knowledgeable, and genuinely invested in our success. We highly recommend them to anyone looking to elevate their online presence!",
  },
];
export default testimonies;
